import React from 'react';
import { DashboardLayout } from '../components/dashboard';
import { AuditDashboard } from '../components/audit';
import { Page } from '../components/ui';

export const AuditPage: React.FC = () => {
  return (
    <DashboardLayout>
      <Page>
        {/* AuditDashboard renders the "Audit" page header with the Log / Trail switch */}
        <AuditDashboard />
      </Page>
    </DashboardLayout>
  );
};
